import React from "react";
import { IMemberWorldData } from "../../exports/interfaces";
import helpPeople1 from "../../assets/images/resources/usa.jpg";
import helpPeople2 from "../../assets/images/resources/south-africa.jpg";
import helpPeople3 from "../../assets/images/resources/brazil.jpg";
import helpPeople4 from "../../assets/images/resources/russia.jpg";
import helpPeople5 from "../../assets/images/resources/australia.jpg";
import { Link } from "react-router-dom";
import { useUserDataContext } from "../../context/UserDataContext";
import { scroller } from "react-scroll";

// import helpPeopleIcon1 from "../../assets/images/icon/help-people-icon-1.png";
// import helpPeopleIcon2 from "../../assets/images/icon/help-people-icon-2.png";
// import helpPeopleIcon3 from "../../assets/images/icon/help-people-icon-3.png";
// import helpPeopleIcon4 from "../../assets/images/icon/help-people-icon-4.png";

const MembersWorld = (props: { memberWorldData: IMemberWorldData[] }) => {
  const { userData } = useUserDataContext();
  const linkClicker = (path: string) => {
      const pathLocation = window.location.pathname.includes(path);
      if (!pathLocation) {
        window.scrollTo(0, 0);
      } else {
        scroller.scrollTo("toTop", {
          duration: 500,
          smooth: true,
        });
      }
    };
  return (
    <section className="help-people">
      <div className="container">
        <div className="row">
          <div className="col-xl-5 col-lg-6">
            <div className="help-people__left">
              <div className="section-title text-left">
                <span className="section-title__tagline">
                  {props?.memberWorldData[0]?.attributes?.Primary_Title}
                </span>
                <h2 className="section-title__title">
                  {props?.memberWorldData[0]?.attributes?.Secondary_Title}
                </h2>
              </div>
              <div className="help-people__content">
                <p className="help-people__text">
                  {props?.memberWorldData[0]?.attributes?.Description}
                </p>
                {/* <a
                  href="/"
                  className="thm-btn help-people__btn"
                >
                  Become a Member
                </a> */}
                {!userData && (
                  <Link
                    to="/become-a-member"
                    // className="donate-btn main-header-two__btn"
                    className="thm-btn main-header-two__btn custom-donate-btn"
                    style={{ paddingLeft: "5px" }}
                    onClick={() => linkClicker("become-a-member")}
                  >
                    {" "}
                    <i className="icon-user-plus"></i>
                    Become a Member
                  </Link>
                )}
              </div>
            </div>
          </div>
          <div className="col-xl-7 col-lg-6">
            <div className="help-people__right">
              <div className="help-people__map-box">
                <div
                  className="help-people__map"
                  style={{
                    backgroundImage: `url(${process.env.REACT_APP_strapiUrl}${props?.memberWorldData[0]?.attributes?.Image?.data?.attributes?.url})`,
                  }}
                ></div>
                <div className="help-people__img help-people__img-1">
                  <img
                    src={helpPeople1}
                    className="zoom-fade"
                    alt="help-people1"
                    style={{
                      objectFit: "cover",
                    }}
                  />
                </div>
                <div className="help-people__img help-people__img-2">
                  <img
                    src={helpPeople2}
                    className="zoom-fade"
                    alt="help-people2"
                    style={{
                      objectFit: "cover",
                    }}
                  />
                </div>
                <div className="help-people__img help-people__img-3">
                  <img
                    src={helpPeople3}
                    className="zoom-fade"
                    alt="help-people3"
                    style={{
                      objectFit: "cover",
                    }}
                  />
                </div>
                <div className="help-people__img help-people__img-4">
                  <img
                    src={helpPeople4}
                    className="zoom-fade"
                    alt="help-people4"
                    style={{
                      objectFit: "cover",
                    }}
                  />
                </div>
                <div className="help-people__img help-people__img-5">
                  <img
                    src={helpPeople5}
                    className="zoom-fade"
                    alt="help-people5"
                    style={{
                      objectFit: "cover",
                    }}
                  />
                </div>
                {/* <div className="help-people__icon-1">
                  <img src={helpPeopleIcon1} alt="" />
                </div>
                <div className="help-people__icon-2">
                  <img src={helpPeopleIcon2} alt="" />
                </div>
                <div className="help-people__icon-3">
                  <img src={helpPeopleIcon3} alt="" />
                </div>
                <div className="help-people__icon-4">
                  <img src={helpPeopleIcon4} alt="" />
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MembersWorld;
